import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import AdminFormLayout from "../components/AdminFormLayout";
import ButtonComponent from "../../components/ButtonComponent";
import { getAdminUploadHeaders } from "../../utils/adminApi";

const AddCategory = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    image: "",
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "image" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const categoryData = new FormData();
      categoryData.append("name", formData.name);

      if (formData.image) {
        categoryData.append("image", formData.image);
      }

      await axios.post(
        "https://api.michelbandalidesign.com/api/category",
        categoryData,
        { headers: getAdminUploadHeaders() }
      );

      toast.success("Category added successfully!");
      navigate("/admin/category");
    } catch (error) {
      console.error("Backend error:", error.response?.data || error.message);
      toast.error(error.response?.data?.error || "Error adding category.");
    }
  };

  return (
    <AdminFormLayout title="Add Category" backTo="/admin/category" backLabel="Back to Categories">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="admin-form-group">
          <label htmlFor="name">Category Name</label>
          <input
            type="text"
            className="form-control admin-all-forms-inputs"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="admin-form-group">
          <label htmlFor="image">Category Image</label>
          <input
            type="file"
            className="form-control admin-all-forms-inputs"
            id="image"
            name="image"
            accept="image/*"
            onChange={handleInputChange}
            required
          />
        </div>

        <ButtonComponent type="submit">Add Category</ButtonComponent>
      </form>
    </AdminFormLayout>
  );
};

export default AddCategory;
